import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';
import styles from './index.modules.less';

const defaultProps = {
  data: [],
  containerStyle: {},
  onPress: null
};

const propTypes = {
  width: PropTypes.any.isRequired, // 宽度 必传
  data: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string, // 图片地址
      title: PropTypes.string, // 标题
      summary: PropTypes.string, // 描述
      content: PropTypes.string, // 内容
      extend: PropTypes.any,
      type: PropTypes.number // 类型
    })
  ), // 数据源
  containerStyle: PropTypes.object, // 容器样式
  onPress: PropTypes.func // 点击事件
};

const ImgTextCell = memo((props) => {
  const {
    width, // any 宽度
    data, // Array 数据源
    containerStyle, // Object 容器样式
    size, // Object 图片尺寸
    onPress // Function 点击事件
  } = props;

  const renderItem = (item, index) => {
    const { imgUrl, title, summary } = item;
    return (
      <Flex
        direction="column"
        align="center"
        key={`ImgTextCell${index}`}
        className={styles.container}
        onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={size.width} h={size.height} />
        <Flex direction="column" align="start" className={styles.info}>
          <div className={styles.title}>
            <span>{title || ''}</span>
          </div>
          <div className={styles.summary}>
            <span>{summary || ''}</span>
          </div>
        </Flex>
      </Flex>
    );
  };

  return (
    <Flex
      direction="row"
      align="center"
      justify="between"
      wrap="wrap"
      style={{ width, ...containerStyle }}>
      <div className={styles.scrollContainer}>
        {data.map((item, index) => renderItem(item, index))}
      </div>
    </Flex>
  );
});

ImgTextCell.defaultProps = defaultProps;
ImgTextCell.propTypes = propTypes;

export default ImgTextCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ImgTextCell/index.js